/**
 * @generated SignedSource<<feb52f7c36ff45b7b11aca7105865db3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddExcludeTreeStartedDispatchConditionInput = {
  clientMutationId?: string | null;
  messageDispatchId: string;
  rootNodeIds: ReadonlyArray<string>;
};
export type useDispatchConditions_AddExcludeTreeStartedDispatchConditionMutation$variables = {
  input: AddExcludeTreeStartedDispatchConditionInput;
};
export type useDispatchConditions_AddExcludeTreeStartedDispatchConditionMutation$data = {
  readonly Admin: {
    readonly Message: {
      readonly addExcludeTreeStartedDispatchCondition: {
        readonly clientMutationId: string | null;
      } | null;
    };
  };
};
export type useDispatchConditions_AddExcludeTreeStartedDispatchConditionMutation = {
  response: useDispatchConditions_AddExcludeTreeStartedDispatchConditionMutation$data;
  variables: useDispatchConditions_AddExcludeTreeStartedDispatchConditionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MessageAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Message",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "AddExcludeTreeStartedDispatchConditionPayload",
            "kind": "LinkedField",
            "name": "addExcludeTreeStartedDispatchCondition",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientMutationId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDispatchConditions_AddExcludeTreeStartedDispatchConditionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDispatchConditions_AddExcludeTreeStartedDispatchConditionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "44ba0e5b9f82403cbbe20cd729fc0721",
    "id": null,
    "metadata": {},
    "name": "useDispatchConditions_AddExcludeTreeStartedDispatchConditionMutation",
    "operationKind": "mutation",
    "text": "mutation useDispatchConditions_AddExcludeTreeStartedDispatchConditionMutation(\n  $input: AddExcludeTreeStartedDispatchConditionInput!\n) {\n  Admin {\n    Message {\n      addExcludeTreeStartedDispatchCondition(input: $input) {\n        clientMutationId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e3eb2ff35fe18bf04d8a5fc66f1545ba";

export default node;
